import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Lux Sensor Icon Style 04 - WB Sunny (Material Symbol)
 */
export const Style04_WbSunny: React.FC<DeviceIconProps> = ({
  isOn = true,
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-orange-400' : 'text-slate-400';

  return (
    <span
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' ${isOn ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      wb_sunny
    </span>
  );
};

export default Style04_WbSunny;
